import { render, staticRenderFns } from "./Failed.vue?vue&type=template&id=05bcc0fc&scoped=true&"
import script from "./Failed.vue?vue&type=script&lang=js&"
export * from "./Failed.vue?vue&type=script&lang=js&"
import style0 from "./Failed.vue?vue&type=style&index=0&id=05bcc0fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bcc0fc",
  null
  
)

export default component.exports